import { render, staticRenderFns } from "./GloboGraphicsTemplatePicker.vue?vue&type=template&id=1b88e416&scoped=true"
import script from "./GloboGraphicsTemplatePicker.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsTemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsTemplatePicker.vue?vue&type=style&index=0&id=1b88e416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88e416",
  null
  
)

export default component.exports